module.exports = __webpack_public_path__ + "img/15.dedb0e33.jpg";